
define('text!ui/template/block-loader.html',[],function () { return '<div data-role="loader" class="loading-mask" style="position: absolute;"><div class="loader"><img src="<%= loaderImageHref %>" alt="Loading..." title="Loading..." style="position: absolute;"></div></div>';});

